export default __webpack_public_path__ + "static/flipImg2-151b0a9a6ffc06f44a41d9596c3c7f85.webp";